export const scrollToTop = (element: HTMLElement) =>
  element.scrollIntoView({
    behavior: 'auto',
    block: 'start',
    inline: 'nearest',
  });
